import { Theme } from "@mui/material";
import { Stage } from "../shared/CaseConfiguration.ts";

/**
 * Stage dot colour, grouped by litigation phase and sourced from the theme
 * palette so it tracks the active (or user-customised) theme:
 * procedural → evidence → trial run-up → trial → post-trial.
 */
export function getStageColor(stage: Stage, theme: Theme): string {
  switch (stage) {
    case Stage.PreAction:
    case Stage.IssueStatementsOfCase:
    case Stage.CMC:
      return theme.palette.info.main;
    case Stage.Disclosure:
    case Stage.WitnessStatements:
    case Stage.ExpertReports:
      return theme.palette.info.dark;
    case Stage.PTR:
    case Stage.TrialPreparation:
      return theme.palette.warning.main;
    case Stage.Trial:
      return theme.palette.error.main;
    case Stage.Appeals:
      return theme.palette.grey[500];
    case Stage.Enforcement:
      return theme.palette.data.positive.main;
  }
}
